module.exports = __webpack_public_path__ + "static/media/icra26haroldspeech.c46e616b.jpeg";